import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-28 text-center">
      <XCircle className="w-14 h-14 text-amber-400 mx-auto" />
      <h1 className="font-serif text-4xl text-cream mt-6">Payment Cancelled</h1>
      <p className="text-muted2 mt-3">No charge was made. Your reservation is saved — you can complete the deposit anytime from My Reservations.</p>
      <div className="flex gap-4 justify-center mt-8">
        <Link to="/reservations" data-testid="payment-cancel-reservations" className="btn-gold">My Reservations</Link>
        <Link to="/catalog" className="btn-silver">Keep Browsing</Link>
      </div>
    </div>
  );
}
